import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

export const GITHUB_INSTALLATION_MESSAGE_ID =
  'hsp.github.installation.finished';

@Component({
  selector: 'app-github-installation-callback',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class GithubInstallationCallbackComponent {
  private readonly route = inject(ActivatedRoute);

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed()).subscribe((params) => {
      const installationId = params['installation_id'];
      if (!installationId) {
        return;
      }
      if (window.opener) {
        (window.opener as Window).postMessage(
          {
            id: GITHUB_INSTALLATION_MESSAGE_ID,
            installationId,
            state: params['state'],
          },
          window.location.origin,
        );
      }
      window.close();
    });
  }
}
